export class StockCheckoutType {
    public symbol: string;
    public adviceId: number;
    public orderId: string;
    public strategyId: string;
    public purchase: boolean;
    public creatingPlanning: boolean;
    public isFuture: boolean;
    public amount: number;
    public inputOrder: any;
    public origin: string;
    public category?: string;
}
